import ApiCall from 'services/ApiCall'

const incotermService = ApiCall._generateCrud('incoterm.master')

export default incotermService
